// USER
export const NOTIF_USER_CREATE_SUCCESS = 'User has been created successfully!';
export const NOTIF_USER_CREATE_ERROR = 'User has not been created!';
export const NOTIF_USER_UPDATE_SUCCESS = 'User has been updated successfully!';
export const NOTIF_USER_UPDATE_ERROR = 'User has not been updated!';
export const NOTIF_USER_EVENT_WRONG = 'Event name is wrong!';
export const NOTIF_FILE_CREATE_ERROR = 'The file has not been created!';

// CONTACT
export const NOTIF_CONTACT_CREATE_SUCCESS = 'Contact has been created successfully!';
export const NOTIF_CONTACT_CREATE_ERROR = 'Contact has not been created!';
export const NOTIF_CONTACT_UPDATE_SUCCESS = 'Contact has been updated successfully!';
export const NOTIF_CONTACT_UPDATE_ERROR = 'Contact has not been updated!';

// LOGIN
export const NOTIF_LOGIN_SUCCESS = 'You are successfully logged in!';
export const NOTIF_LOGIN_ERROR = 'You are not logged in!';

// MENUS
export const NOTIF_MENU_CREATE_SUCCESS = 'CatTab has been created successfully!';
export const NOTIF_MENU_CREATE_ERROR = 'CatTab has not been created!';
export const NOTIF_MENU_UPDATE_SUCCESS = 'CatTab has been updated successfully!';
export const NOTIF_MENU_UPDATE_ERROR = 'CatTab has not been updated!';
export const NOTIF_MENU_DELETE_SUCCESS = 'CanTab has been deleted suqccessfully!';
export const NOTIF_MENU_DELETE_ERROR = 'CanTab has not been deleted!';
